/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sub_CancelInputs */

const en_settings_sub_cancel = /** @type {(inputs: Settings_Sub_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel subscription`)
};

const id_settings_sub_cancel = /** @type {(inputs: Settings_Sub_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batalkan langganan`)
};

/**
* | output |
* | --- |
* | "Cancel subscription" |
*
* @param {Settings_Sub_CancelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_cancel = /** @type {((inputs?: Settings_Sub_CancelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_CancelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_cancel(inputs)
	return en_settings_sub_cancel(inputs)
});